'use client';

import { VideoCircle } from '@insta-club/components';
import { t } from '@insta-club/translations';

interface Props {
    title?: string;
    onClick?: () => void;
}

export default function HelpButton({ onClick, title = t('video_guide') }: Props) {
    return (
        <button onClick={onClick} className='flex cursor-pointer items-center'>
            <VideoCircle className='text-primary-500' />
            <span className='text-primary-500 mr-1 text-sm font-semibold text-nowrap'>{title}</span>
        </button>
    );
}

